export default __webpack_public_path__ + "static/media/contact.672b4efc.svg";